import { SVGProps } from 'react';

const LoaderPinwheel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 12a5 5 0 1 1-10 0m10 0c0 5.523-4.477 10-10 10S2 17.523 2 12m20 0c0-5.523-4.477-10-10-10S2 6.477 2 12m10 0a5 5 0 0 0-10 0m10 0a5.018 5.018 0 0 0-5 8.7m5-8.7a4.974 4.974 0 0 0 5-8.6M7 3.3a4.974 4.974 0 0 1 5 8.6 4.974 4.974 0 0 0 5 8.6"
    />
  </svg>
);
export default LoaderPinwheel;
